import type { challenges as en } from '@/i18n/locales/en/challenges';
import type { Translation } from '@/i18n/types';

/** See `src/i18n/locales/en/challenges.ts`. */
export const challenges: Translation<typeof en> = {
  page: {
    title: 'Desafios',
    lead: 'Organize desafios de equipa: passos, sono, treinos e mais, com uma tabela classificativa opcional.',
    noCompany: 'Selecione uma empresa para ver os seus desafios.',
    forbidden: 'Não tem acesso aos desafios desta empresa.',
    empty: 'Ainda não há desafios — crie o primeiro.',
  },
  counts: {
    active: 'Desafios ativos',
    draft: 'Rascunhos',
    completed: 'Concluídos',
    totalParticipants: 'Total de participantes',
  },
  sections: {
    activePublished: 'Ativos e publicados',
    draftsCompleted: 'Rascunhos e concluídos',
  },
  card: {
    type: 'Tipo',
    mode: 'Modalidade',
    period: 'Período',
    goal: 'Objetivo',
    reward: 'Recompensa',
    participants: 'Participantes',
    engagement: 'Envolvimento',
    completion: 'Conclusão',
    leaderboardVisible: 'Tabela classificativa visível',
    leaderboardHidden: 'Tabela classificativa oculta',
  },
  mode: {
    individual: 'Individual',
    group: 'Equipa',
  },
  status: {
    draft: 'Rascunho',
    active: 'Ativo',
    paused: 'Em pausa',
    completed: 'Concluído',
  },
  type: {
    steps: 'Passos',
    sleep: 'Sono',
    workouts: 'Treinos',
    meditation: 'Meditação',
    custom: 'Personalizado',
  },
  actions: {
    newChallenge: 'Novo desafio',
    publish: 'Publicar',
    pause: 'Pausar',
    resume: 'Retomar',
    finish: 'Terminar',
    duplicate: 'Duplicar como rascunho',
    duplicateSuffix: 'cópia',
    viewLeaderboard: 'Ver tabela classificativa',
    hideLeaderboard: 'Ocultar tabela classificativa',
  },
  leaderboard: {
    title: 'Tabela classificativa',
    empty: 'Ainda não há participantes.',
  },
  form: {
    title: 'Novo desafio',
    submit: 'Criar desafio',
    cancel: 'Cancelar',
    fields: {
      title: 'Título',
      description: 'Descrição',
      type: 'Tipo',
      mode: 'Modalidade',
      startDate: 'Data de início',
      endDate: 'Data de fim',
      goalValue: 'Valor do objetivo',
      unit: 'Unidade',
      reward: 'Recompensa',
      leaderboardVisible: 'Mostrar a tabela classificativa aos participantes',
    },
    errors: {
      required: 'Este campo é obrigatório.',
      endBeforeStart: 'A data de fim não pode ser anterior à data de início.',
    },
  },
};
